import React from 'react'
import { IBook } from '../../types'
import { Flex } from '@radix-ui/themes'
import { BookItem } from './book-item'

interface IBookShelfProps {
  books: IBook[]
  style: any
  bookWidth: number
}

export const BookShelf: React.FC<IBookShelfProps> = ({ books, style, bookWidth }) => {
  return (
    <Flex style={style} pb="4" direction="row" justify="start">
      {
        books.map(book => <BookItem book={book} key={book.uuid} width={bookWidth}/>)
      }
    </Flex>
  )
}
